// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/calendar-days.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/calendar-days'

import { Icon, type IconComponentProps } from '../icon'

export const CalendarDaysIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
